import styled from "@emotion/styled";
import { Link } from "react-router-dom";

export const FooterContainer = styled.footer`
    padding: 24px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    z-index: 1300;
    flex-shrink: 0;
`;

export const FooterTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10px;
  gap: 8px;
`;

export const FooterCopyrightSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  order: 1;
  text-align: center;
`;

export const FooterCopyright = styled.div`
  font-weight: 500;
  line-height: 40px;
`;

export const FooterDotDivider = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ theme }) => theme.palette.common.white};
  margin: 0 64px;
`;

export const FooterLinksSection = styled.div`
  display: flex;
  gap: 16px;
`;

export const FooterLink = styled(Link)`
  color: ${({ theme }) => theme.palette.secondary.main};
`;

export const FooterActionButton = styled.button`
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.palette.secondary.main};
  font: inherit;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
`;

export const FooterHintText = styled.div`
  color: ${({ theme }) => theme.palette.secondary.main};
  font-size: 10px;
  opacity: 0.9;
`;

export const FooterSocialSection = styled.div`
  display: flex;
  gap: 16px;
  color: ${({ theme }) => theme.palette.secondary.main};
`;

export const SocialLink = styled.a`
  color: ${({ theme }) => theme.palette.secondary.main};
  transition: color 0.3s ease;
`;

// Social media icon wrapper
export const SocialIcon = styled.svg`
  width: 24px;
  height: 24px;
  vertical-align: top;
`;

export const FooterSoftwareCredit = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;

  margin-top: 6px;
  color: ${({ theme }) => theme.colors.text.lightgrey};
  opacity: 0.55;
  font-size: 11px;
  letter-spacing: 0.02em;
  text-align: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 10px;
  }
`;

export const FooterForgeMark = styled.svg`
  width: 12px;
  height: 14px;
  flex-shrink: 0;
`;
